import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrash, faPen } from "@fortawesome/free-solid-svg-icons";
import Replicate_Testing_view_offcanvas from "../replicate_Testing_view_offcanvas/Replicate_Testing_view_offcanvas";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import Image_Show_Modal from "../../../../../../../../common/common_modal/image_show_modal/image_show_modal";
import { formatDate } from "../../../../../../../../utils/common";
import Replicate_Testing_Edit_Offcanvas from "../Replicate_Testing_Edit_Offcanvas/Replicate_Testing_Edit_Offcanvas";
import { FixIDS } from "../../../../../../../../utils/fixIDS";
import { useSelector } from "react-redux";
import {
  Delete,
  GetAll,
} from "../../../../../../../../features/admin/quality_management/process_requirement/validity/Slice";

function Replicate_Testing_table({
  validitydetails,
  setCurrentPage,
  currentPage,
  openDeleteModal,
  validityTypeId,
}) {
  const [view, setView] = useState(false);
  const perPage = validitydetails?.per_page;

  const filteredData = validitydetails?.data || [];
  const totalPages = validitydetails?.total_pages;

  const [showEdit, setEdit] = useState(false);
  const [showEditId, setEditId] = useState(null);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const maxObservations = Math.max(
    ...(filteredData || []).map(
      (item) => item.Validity_Type_Record_Observations?.length || 0,
    ),
    0,
  );

  const permissions = useSelector((state) => state.auth.permissions);

  const haveEditPermission = permissions?.includes(
    FixIDS.replicate_testing.Edit,
  );
  const haveDeletePermission = permissions?.includes(
    FixIDS.replicate_testing.Delete,
  );
  const haveViewPermission = permissions?.includes(
    FixIDS.replicate_testing.View,
  );

  const [show, setShow] = useState(false);

  const [showData, setShowData] = useState("");

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th rowSpan="2">Sr. No</th>
                  <th rowSpan="2">Date</th>
                  <th rowSpan="2">Test Parameter</th>
                  <th rowSpan="2">Sample ID</th>
                  <th rowSpan="2">Certified Value</th>
                  <th rowSpan="2">Test Method</th>
                  <th colSpan={maxObservations}>Observations</th>
                  <th rowSpan="2">Avg.</th>
                  <th rowSpan="2">Tested By</th>
                  <th rowSpan="2">Remark</th>
                  <th rowSpan="2">Action</th>
                  {/* <th rowSpan="2">Remark</th>
                  //  */}
                </tr>
                <tr>
                  {Array.from({ length: maxObservations }).map((_, i) => (
                    <th key={i}>OBS {String(i + 1).padStart(2, "0")}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {filteredData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{formatDate(item?.createdAt || "-")}</td>
                    <td>{item.Test_Type?.name || "-"}</td>
                    <td>{item.Sample_Management?.unique_id || "-"}</td>
                    <td>{item.certified_value || "-"}</td>
                    <td>{item.Test_Method?.name || "-"}</td>

                    {/* Display up to 5 observations */}
                    {Array.from({ length: maxObservations }).map(
                      (_, obsIndex) => (
                        <td key={obsIndex}>
                          {item.Validity_Type_Record_Observations?.[obsIndex]
                            ?.observation_value || "-"}
                        </td>
                      ),
                    )}

                    <td>{item.average || "-"}</td>
                    <td>{item.Tested_By?.name || "-"}</td>
                    <td>{item.remark || "-"}</td>
                    <td>
                      {/* <div
                        className="action_icons"
                        onClick={() => {
                          setShow(true);
                          setShowData(item);
                        }}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </div> */}
                      <div className="action_icons">
                        <span>
                          {" "}
                          {haveViewPermission && (
                            <FontAwesomeIcon
                              icon={faEye}
                              onClick={() => {
                                setShow(true);
                                setShowData(item);
                              }}
                            />
                          )}
                        </span>

                        {haveEditPermission && (
                          <FontAwesomeIcon
                            icon={faPen}
                            onClick={() => {
                              setEdit(true);
                              setEditId(item.id);
                            }}
                          />
                        )}

                        <span
                          title="Delete"
                          style={{ cursor: "pointer", color: "#dc3545" }}
                        >
                          {haveDeletePermission && (
                            <FontAwesomeIcon
                              icon={faTrash}
                              onClick={() => openDeleteModal(item?.id)}
                              size="lg"
                            />
                          )}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="comon_page_footer">
          <div className="show_entry_div">
            <p className="show m-0">
              {`Showing ${Math.min(
                (currentPage - 1) * perPage + 1,
              )} to ${Math.min(
                currentPage * perPage,
                validitydetails?.total,
              )} of ${validitydetails?.total} entries`}
            </p>
          </div>

          <div className="pagination_div">
            <Pagination_Holder
              onPageChange={currentPage}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>
      {/* VIEW */}
      <Replicate_Testing_view_offcanvas
        show={view}
        handleClose={() => setView(false)}
      />
      <Image_Show_Modal
        onHide={() => setShow(false)}
        show={show}
        showData={showData}
        imgSrc={process.env.REACT_APP_IMG_URL + showData?.attach_file}
      />

      {/* Edit */}
      {haveEditPermission && (
        <Replicate_Testing_Edit_Offcanvas
          show={showEdit}
          handleClose={() => setEdit(false)}
          id={showEditId}
          validityTypeId={validityTypeId}
        />
      )}
    </>
  );
}

export default Replicate_Testing_table;
